{
  "A company already exists with this name": "Ja existeix una empresa amb aquest nom",
  "a-stage-that-is-set-as-default-from-partner-preferences-can-only-be-generic": "Una etapa que és predeterminada a les preferències d'un soci només pot ser genèrica",
  "a-stage-that-is-set-as-default-of-a-workflow-can-only-be-generic": "Una etapa que és predeterminada d'un flux de treball només pot ser genèrica",
  "About": "Quant a",
  "Accept": "Acceptar",
  "Accept partner orders automatically": "Acceptar comandes de socis automàticament",
  "Accept partnership": "Accepta la col·laboració",
  "accept_partnership.description": "Ara sou socis de {company}.",
  "accept_partnership.title": "Enhorabona!",
  "accepted": "Acceptat",
  "Accepted": "Acceptat",
  "accepted-plural": "Acceptats",
  "Actions": "Accions",
  "Active": "Actiu",
  "ActivitiesHistory": "Historial d'activitats",
  "Activity history": "Historial d'Activitats",
  "Add": "Afegir",
  "Add Action": "Afegir acció",
  "Add another": "Afegir un altre",
  "Add items first": "Afegeix ítems primer",
  "Add new": "Afegir nou",
  "Add new service": "Afegir servei nou",
  "Add Rating": "Afegir una puntuació",
  "Add workflow": "Afegir un flux de treball",
  "Address": "Adreça",
  "Admin": "Admin",
  "Administration": "Administració",
  "alias": "Àlies",
  "Alias": "Àlies",
  "All": "Totes",
  "All orders": "Totes",
  "All order items": "Tots",
  "Analytics": "Analítiques",
  "and": "i",
  "Api Keys Management": "Gestió de claus API",
  "Api_keys_description": "Les claus de l'API et permeten interactuar amb la nostra API REST i connectar aplicacions com Control Center o neoCatalog amb Inèdit Connect. \nTingues en compte que la nova clau generada només es mostrarà una vegada, així que assegura't de copiar-la i desar-la en un lloc de segur.",
  "Application Preferences": "Preferències d'aplicació",
  "Apply": "Aplicar",
  "Archive": "Arxivar",
  "Archived": "Arxivat",
  "Are you sure you want to delete the selected Users": "Estàs segur que vols suprimir l'usuari seleccionat?|Estàs segur que vols suprimir els usuaris seleccionats?",
  "Are you sure you want to delete this service": "Estàs segur que vols suprimir aquest servei?",
  "Are you sure you want to exit without saving": "Estàs segur que vols sortir sense desar?",
  "are-you-sure-delete-ink": "Estàs segur que vols suprimir aquesta tinta?|Estàs segur que vols suprimir aquestes tintes?",
  "are-you-sure-delete-printer": "Estàs segur que vols eliminar aquesta impressora?",
  "are-you-sure-you-want-to-delete-this-company": "Estàs segur que vols suprimir aquesta empresa?",
  "As the order has no items it will be deleted": "Com que l'ordre no té articles, s'eliminarà",
  "At least one lowercase": "Almenys una minúscula",
  "At least one numeric": "Almenys un numèric",
  "At least one uppercase": "Almenys una majúscula",
  "Block": "Bloquejar",
  "Blocked": "Bloquejats",
  "By date": "Per data",
  "Cancel": "Cancel·lar",
  "cant delete workflow with orders": "No es pot suprimir un flux de treball amb ordres",
  "cant-delete-item-because-it-has-been-sent-to-a-partner": "No es pot suprimir l'ítem perquè s'ha enviat a un soci",
  "cant-delete-ítem-because-it-has-been-sent-to-a-partner": "No es pot suprimir l'element perquè s'ha enviat a un soci",
  "centimeters": "Centímetres",
  "Centimeters": "Centímetres",
  "changed": "canviat",
  "Changes not saved": "Canvis no desats",
  "Check your email": "Comprova el teu correu",
  "Choose a material first": "Primer tria un material",
  "Choose destinataries": "Tria destinataris",
  "City": "Ciutat",
  "Clear": "Esborrar",
  "Close": "Tancar",
  "Code": "Codi",
  "Color": "Color",
  "Columns": "Columnes",
  "comment": "comentari",
  "Comment": "Comentari",
  "Comment deleted successfully": "El comentari s'ha suprimit correctament",
  "Comments": "Comentaris",
  "Companies": "Empreses",
  "Company": "Empresa",
  "Company Address": "Adreça de l'empresa",
  "Company alias": "Àlies de l'empresa",
  "company description placeholder": "Explica'ns alguna cosa sobre la teva empresa perquè els teus socis et puguin conèixer millor. \nEx.: Quins productes o serveis ofereix la teva empresa? \nCom es diferencia la teva empresa de la competència?",
  "Company information saved": "S'ha guardat la informació de l'empresa",
  "Company name": "Nom de l'empresa",
  "Company ratings": "Valoracions de l'empresa",
  "Company street": "Carrer de l'empresa",
  "company-info": "Informació de l'empresa",
  "company-name-preferences": "Preferències de {name}",
  "company-successfully-deleted": "L'empresa s'ha suprimit correctament",
  "Confirm": "Confirmar",
  "contactUs": "Contacta amb nosaltres",
  "Contains": "Conté",
  "Continue": "Continuar",
  "Continue without saving": "Continua sense desar",
  "copies": "Còpies",
  "Copies": "Còpies",
  "Copy": "Copiar",
  "Cotton": "Cotó",
  "couldnt-connect-to-the-server-please-try-again-later": "No s'ha pogut connectar al servidor. \nSi us plau, intenta-ho més tard.",
  "Country": "País",
  "Create": "Crear",
  "CREATE": "CREAR",
  "Create today!": "Crea'l avui!",
  "create-new-company": "Crear una nova empresa",
  "created": "Creat",
  "created this order item": "{name} has creat aquest ítem|{name} ha creat aquest ítem",
  "created a print job for this order item": "{name} has creat un treball d'impressió per a aquest ítem|{name} ha creat un treball d'impressió per a aquest ítem",
  "created this order ítem": "ha creat aquest ítem",
  "Creation Date": "Data de creació",
  "Customer": "Client",
  "cutting": "Tall",
  "Dashboard": "Consola",
  "Date": "Data",
  "Date Created": "Data de creació",
  "Date is": "La data és",
  "Date is after": "La data és posterior a",
  "Date is before": "La data és abans de",
  "Date is not": "La data no és",
  "date-placeholder": "dd/mm/aaaa",
  "Default Scheme": "Esquema predeterminat",
  "Default Stage": "Etapa predeterminada",
  "Default workflow": "Flux de treball predeterminat",
  "Default workflow stage": "Etapa del flux de treball predeterminada",
  "default-workflow-stage-for-incoming-orders-must-be-a-generic-stage": "L'etapa predeterminada per les comandes entrants ha de ser una etapa genèrica",
  "Delete": "Suprimir",
  "DELETE": "ELIMINAR",
  "Delete Items": "Suprimir elements",
  "Delete service": "Suprimir el servei",
  "Delete Workflow": "Suprimir el flux de treball",
  "Delivery Date": "Data de lliurament",
  "Description": "Descripció",
  "Designer Brand": "Marca de disseny",
  "Designing": "Disseny",
  "Discard changes": "Descartar els canvis",
  "Discover": "Descobrir",
  "Discover new partners": "Descobrir nous socis",
  "Do not have an account?": "No tens un compte?",
  "Do you want to archive this order items": "Vols arxivar aquest ítem?|Vols arxivar aquests ítems?",
  "Do you want to delete this items This action cannot be undone": "Vols suprimir aquests elements? Aquesta acció no es pot desfer",
  "Do you want to delete this order items": "Vols eleiminar l'ítem?|Vols eliminar els {count} ítems?",
  "Do you want to delete this order?": "Vols suprimir aquesta ordre?",
  "Do you want to delete this response": "Vols suprimir aquesta resposta?",
  "Do you want to delete this stage": "Vols suprimir aquesta etapa?",
  "Do you want to delete this token?": "Vols suprimir aquesta clau?",
  "Do you want to delete this workflow Changes cant be undone": "Vols suprimir aquest flux de treball? \nAquesta acció no es pot desfer",
  "Do you want to split this ítem? A new order with _split suffix will be created": "Vols dividir aquest element? \nEs crearà una ordre nova amb el sufix _split|Vols dividir aquests elements? \nEs crearà un ordre nou amb el sufix _split",
  "do-you-want-delete-this-partnership": "Vols suprimir aquest soci?",
  "do-you-want-to-block-this-partnership": "Vols bloquejar aquest soci?",
  "do-you-want-to-delete-this-company": "Vols suprimir aquesta empresa? \nS'eliminaran totes les dades, incloses ordres, usuaris, fluxos de treball, etc.",
  "Done": "Acabat",
  "Download": "Descarregar",
  "download-csv": "Descarregar CSV",
  "Drag and drop a file here to upload": "Arrossega i deixa anar un fitxer aquí per carregar-lo",
  "Drag and drop files here to upload": "Arrossega i deixa anar els fitxers aquí per carregar-los.",
  "Drag and drop orders here to send them to the printer mill": "Arrossega i deixa anar les ordres aquí per enviar-les al centre d'impressió",
  "Edit": "Editar",
  "EDIT": "EDITAR",
  "Edit Material": "Editar material",
  "Edit MaterialType": "Editar Material",
  "Edit review": "Edita la ressenya",
  "Edited at": "Editat el",
  "edited_successfully": " editat amb èxit",
  "email": "correu electrònic",
  "Email": "Correu electrònic",
  "Email already taken": "Correu electrònic ja utilitzat",
  "Email is not valid": "El correu electrònic no és vàlid",
  "Email is required": "El correu electrònic és obligatori",
  "Email not allowed": "Correu electrònic no permès",
  "email-address": "Adreça electrònica",
  "email-sent": "Correu electrònic enviat",
  "Ends with": "Acaba amb",
  "Equals": "És igual",
  "Error accepting invitation": "S'ha produït un error acceptant la invitació",
  "Error creating stage": "Error creant l'etapa",
  "Error deleting workflow": "Error en suprimir el flux de treball",
  "Error downloading file": "S'ha produït un error en baixar el fitxer",
  "Error rejecting invitation": "S'ha produït un error rebutjant la invitació",
  "Error saving workflow": "S'ha produït un error en desar el fluxe de treball",
  "Error updating stage": "Error actualitzant l'etapa",
  "Error while archiving order ítem": "S'ha produït un error en arxivar l'ítem",
  "Error while saving partner preferences": "S'ha produït un error en desar les preferències del soci",
  "Error while saving rating": "S'ha produït un error en desar la ressenya",
  "error-saving-permissions": "S'ha produït un error en desar els permisos",
  "error-sending-email": "S'ha produït un error en enviar el correu electrònic",
  "error-uploading-file": "Error carregant el fitxer",
  "Expired": "Caducat",
  "Failed to save company information": "No s'ha pogut desar la informació de l'empresa",
  "Features": "Funcionalidades",
  "Feet": "Peus",
  "File": "Fitxer",
  "a new file": "un fitxer nou",
  "File History": "Historial de fitxers",
  "File Name": "Nom de l'arxiu",
  "file-name": "Nom de l'arxiu",
  "file-uploaded-successfully": "El fitxer s'ha pujat correctament",
  "Filter by": "Filtra per",
  "finish_signup": {
    "description": "Estàs a un sol pas de crear el teu compte!",
    "title": "Quasi llest!"
  },
  "Finished": "Acabat",
  "first": {
    "agree": "Continuant, acceptes els nostres {terms} i que has llegit la nostra {data-use-policy}, inclòs {cookies-use}.",
    "description": "S'utilitzarà com a administrador de l'empresa",
    "title": "Primer, digue'ns el teu correu electrònic i contrasenya"
  },
  "Fix the errors in the form before continuing": "Corregeix els errors del formulari abans de continuar",
  "Do you want to delete this item? This action cannot be undone.": "Vols suprimir aquest element? Aquesta acció no es pot desfer.",
  "Force touch displays accessibility": "Força l'accessibilitat per a les pantalles tàctils",
  "forgot_password_description": "Introdueix el teu correu electrònic a continuació, si és una adreça vàlida, us enviarem un correu electrònic amb les instruccions per restablir la teva contrasenya",
  "forgot-password": "Has oblidat la contrasenya?",
  "Generate": "Generar",
  "Generic": "Genèric",
  "generic-column-with-no-special-dividers": "Genèric: columna sense separadors especials",
  "Global Settings": "Configuració global",
  "go back to": "tornar a {name}",
  "Go to login page": "Anar a la pàgina d'inici de sessió",
  "Greater than": "Més gran que",
  "Greater than or equal to": "Major o igual a",
  "Guest": "Convidat",
  "hello": "Hola",
  "Hello World!": "Hola Mon!",
  "Hidden": "Ocult",
  "history-description": "la descripció",
  "history-length": "la llargada",
  "history-lengthUnits": "les unitats de longitud",
  "history-position": "la posició",
  "history-quantity": "la quantitat",
  "history-status": "l'estat",
  "history-width": "l'amplada",
  "history-widthUnits": "les unitats d'amplada",
  "Home": "Inici",
  "Icon": "Icona",
  "idle": "Inactiva",
  "Idle": "Inactiva",
  "in": "in",
  "In queue": "En cua",
  "inches": "Polzades",
  "Inches": "Polzades",
  "Incoming Orders": "Ordres entrants",
  "ineditLong": "Inèdit Software SL",
  "InkType created successfully": "El tipus de tinta s'ha creat correctament",
  "InkType deleted successfully": "El tipus de tinta s'ha suprimit correctament",
  "InkTypes": "Tipus de tinta",
  "Invite": "Convidar",
  "It will we displayed publicly": "Es mostrarà públicament",
  "items": "ítem|ítems",
  "Items": "Ítems",
  "items_deleted_successfully": "Elements eliminats amb èxit|{count} elements eliminats amb èxit",
  "items_plural": "Ítems",
  "items-by-company": "Articles per empresa",
  "JoinNow": "Unir-se ara!",
  "Last Used": "Última utilització",
  "last-3-months": "Últims 3 mesos",
  "last-7-days": "Últims 7 dies",
  "last-30-days": "Últims 30 dies",
  "last-365-days": "Últims 365 dies",
  "last-month": "El mes passat",
  "length": "llargada",
  "Length": "Llargada",
  "length-units": "Unitats de llargada",
  "lengthUnits": "Unitats de longitud",
  "Less than": "Menys que",
  "Less than or equal to": "Menor o igual a",
  "Licenses": "Llicències",
  "Linen": "Lli",
  "loading": "Carregant...",
  "Loading material types data": {
    " Please wait": "Carregant dades de tipus de material. \nSi us plau, espera"
  },
  "Loading materialTypes data_Please wait": "Carregant dades de materials. \nSi us plau, espera",
  "Loading printers data": {
    " Please wait": "Càrrega de dades de la impressora. \nSi us plau, espera"
  },
  "loading-customers-data-please-wait": "Carregant les dades dels clients. \nSi us plau, espera.",
  "Log In": "Iniciar Sessió",
  "Login": "Iniciar Sessió",
  "Logout": "Tancar sessió",
  "mail_not_received": "No has rebut el correu electrònic? \nComproveu la teva carpeta de correu brossa o",
  "mail_sent_description": "Hem enviat un correu electrònic a la teva adreça de correu electrònic amb instruccions per restablir la teva contrasenya",
  "Manage ink types": "Gestioneu els tipus de tinta",
  "Manage material types": "Gestionar tipus de materials",
  "Manage MaterialTypes": "Gestionar substrats",
  "Manage Workers": "Gestionar els treballadors",
  "Manager": "Gerent",
  "Match All": "tots han de conincidir",
  "Match Any": "Coincideix amb qualsevol",
  "Material": "Material",
  "Material deleted successfully": "El material s'ha suprimit correctament",
  "Material Type": "Tipus de material",
  "Material Types": "Tipus de material",
  "material-edited-successfully": "Material editat correctament",
  "material-updated-successfully": "Material actualitzat correctament",
  "there-was-an-error-updating-the-material": "Hi ha hagut un error en actualitzar el material",
  "material-type-is-required": "El tipus de material es obligatori.",
  "material-width-is-required": "Les unitats són necessàries",
  "Materials": "Materials",
  "MaterialType": "Material",
  "MaterialType created successfully": "Material creat correctament",
  "MaterialType deleted successfully": "El substrat s'ha suprimit correctament",
  "MaterialType updated successfully": "El material s'ha actualitzat correctament",
  "MaterialType with this name already exists": "Tipus de material amb nom aquest nom ja existeix",
  "MaterialTypes": "Substrats",
  "MaterialTypes Management": "Administració de Materials",
  "Max": "Fins",
  "Measure": "Mesura",
  "medium": "Mig",
  "message": "Hola i18n !!",
  "meters": "Metres",
  "Meters": "Metres",
  "Min": "Desde",
  "Minimum 8 characters": "Mínim 8 caràcters",
  "Move to stage": "Passar a l'etapa",
  "name": "nom",
  "Name": "Nom",
  "name-is-required": "El nom és obligatori.",
  "New Comment:": "Nou comentari:",
  "New Ink Type": "Nou tipus de tinta",
  "New Material": "Nou material",
  "New Material Type": "Nou tipus de material",
  "New MaterialType": "Nou material",
  "New Order": "Nova Ordre",
  "New print Order": "Nova ordre d'impressió",
  "New token": "Nova clau",
  "New Token": "Nova Clau",
  "No": "No",
  "No actions selected": {
    " Add actions with button below": "No s'ha seleccionat cap acció. \nAfegeix accions amb el següent botó."
  },
  "No comments yet": "Encara no hi ha comentaris",
  "No Filter": "Sense filtre",
  "No image file": "Ítem sense fitxer",
  "No ink types found": "No s'han trobat tipus de tinta",
  "No material types found": "No s'han trobat tipus de materials",
  "No materials found": "No s'han trobat materials",
  "No partner": "Sense Soci",
  "No printers found": "No s'han trobat impressores",
  "No statuses found": "No s'han trobat estats",
  "no_delete_self": "No pots eliminar-te a tu mateix",
  "no-customers-found": "No s'han trobat clients",
  "no-incoming-items-found": "No s'han trobat ordres entrants",
  "no-partners-column": "Per enviar un ítem a un soci, primer has de crear una columna de \"tipus partner\".",
  "Not contains": "No conté",
  "Not equals": "No és igual",
  "Not specified": "No especificat",
  "now-tell-us-your-company-name": "Digue'ns el nom de la teva empresa",
  "Number": "Número",
  "Ok": "D'acord",
  "Only alphanumeric characters are allowed": "Només es permeten caràcters alfanumèrics",
  "Order": "Ordre",
  "Order Code": "Codi d'ordre",
  "Object Size": "Mida de l'objecte",
  "Order created successfully": "L'ordre s'ha creat correctament",
  "Order deleted successfully": "L'ordre s'ha suprimit correctament",
  "Order edited successfully": "Ordre editada correctament",
  "Order has been completed": "L'ordre s'ha completat",
  "Order has been rejected": "L'ordre ha estat rebutjada",
  "Order has no items": "L'ordre no té articles",
  "Order is being worked on": "S'està treballant en l'ordre",
  "Order Item": "Ítem ",
  "Order ítem archived successfully": "L'ítem s'ha arxivat correctament",
  "Order ítem has been archived": "L'ítem s'ha arxivat",
  "Order items": "Articles",
  "Order items archived successfully": "Els elements de l'ordre s'han arxivat correctament",
  "Order items deleted successfully": "Els ítems de l'ordre s'han suprimit correctament",
  "Order Name": "Nom de l'ordre",
  "Order received to be reviewed and accepted or rejected": "Ordre rebuda per tal de ser revisada i acceptada o rebutjada",
  "Order that has been received": "Ordre que s'ha rebut",
  "order-items-by-customer": "Ítems per soci",
  "order-items-by-material-type": "Ítems per tipus de material",
  "order-items-by-status": "Ítems per estat",
  "order-items-by-workflow-stage": "Ítems per etapa",
  "Orders": "Ordres",
  "pagination-text": "Mostrant {first} de {totalRecords} entrada|Mostrant de {first} a {last} de {totalRecords} entrades",
  "partner": "Soci",
  "Partner preferences saved successfully": "Les preferències dels socis s'han desat correctament",
  "Partners": "Socis",
  "Partners discovery": "Descobrir socis",
  "Partners since": "Socis des de",
  "partners-column-with-sections-for-each-one-of-the-companys-partners": "Socis: Columna amb apartats per a cadascun dels socis de l'empresa",
  "Partnership rejected successfully": "La sol·licitud de col·laboració s'ha rebutjat correctament",
  "Password": "Contrasenya",
  "password": "Contrasenya",
  "password_reset": {
    "description": "Si us plau, introdueix la teva nova contrasenya a continuació",
    "title": "Nova contrasenya"
  },
  "Pending": "Pendent",
  "Pending invitations": "Invitacions pendents",
  "Permissions": "Permisos",
  "permissions-saved": "Permisos desats",
  "Phone number": "Número de telèfon",
  "pick-a-password": "Tria una contrasenya",
  "Pieces": "Peces",
  "pixels": "Píxels",
  "Please enter a reason for rejection": "Introdueix el motiu del rebuig",
  "Please fill in all fields": "Si us plau, omple tots els camps",
  "Please fill in all required fields": "Si us plau, ompli tots els camps obligatoris",
  "Please save or cancel the changes before adding another stage": "Desa o cancel·la els canvis abans d'afegir una altra etapa",
  "Please save or cancel the changes before editing another stage": "Desa o cancel·la els canvis abans d'editar una altra etapa",
  "please-enter-the-email-address-of-one-of-the-allowed-super-admins-we-will-send-you-an-email-with-instructions-on-how-to-access": "Introdueix l'adreça electrònica d'un dels superadministradors permesos. \nT'enviarem un correu electrònic amb les instruccions per accedir-hi.",
  "Port": "Port",
  "position": "posició",
  "Preferences": "Preferències",
  "Price": "Preu",
  "Prices": "Preus",
  "printer deleted successfully": "La impressora s'ha suprimit correctament",
  "Printer deleted successfully": "La impressora s'ha suprimit correctament",
  "Printer Mill": "Centre d'impressió",
  "Printers": "Impressores",
  "printers-column-with-sections-for-each-one-of-the-companys-printers": "Impressores: Columna amb seccions per a cadascuna de les impressores de l'empresa",
  "Printing": "Impressió",
  "Private Comment": "Comentari privat",
  "Product": "Producte",
  "Public": "Públic",
  "Public comment": "Comentari públic",
  "public-comment-tooltip": "Si aquest ítem es comparteix amb un soci, aquest podrà veure els comentaris públics",
  "Publish": "Publicar",
  "Quantity": "Quantitat",
  "quantity-cant-be-0": "La quantitat no pot ser 0",
  "Rating": "Valoració",
  "Rating saved successfully": "La ressenya s'ha desat correctament",
  "ratings": "ressenya|ressenyes",
  "Reason for rejection": "Motiu del rebuig",
  "Reject": "Rebutjar",
  "Reject order": "Rebutjar ordre",
  "Reject partnership": "Rebutja col·laboració",
  "rejected": "Rebutjat",
  "Remember me": "Recorda'm",
  "Replace file": "Substituir el fitxer",
  "replied": "ha respòs",
  "Reply": {
    "": "Responder..."
  },
  "Reset your password": "Restablir la contrasenya",
  "reset_ok": {
    "description": "Ara pots iniciar sessió amb la teva nova contrasenya.",
    "title": "S'ha recuperat la contrasenya"
  },
  "reset_password_description": "Introdueix el correu electrònic associat al teu compte i us enviarem un correu electrònic amb un enllaç i instruccions per restablir la teva contrasenya",
  "Reset to default": "Restablir els valors predeterminats",
  "Role": "Rol",
  "Roles": "Rols",
  "Roles & Permissions": "Rols i permisos",
  "Save": "Guardar",
  "Save changes": "Guardar canvis",
  "Scheme files": "Fitxers de l'esquema",
  "Schemes": "Esquemes",
  "Schemes for": "Esquemes per",
  "Search": "Cerca",
  "Search by code": "Cerca per codi",
  "Search by description": "Cerca per descripció",
  "Search by file": "Cerca per fitxer",
  "Search by ink types": "Cerca per tipus de tinta",
  "Search by name": "Cerca per nom",
  "Search by units": "Cerca per unitats",
  "second": {
    "description": "Aquest sera el nom utilitzar per connectar amb els socis",
    "title": "Ara, diga'ns el nom de la teva empresa"
  },
  "second.description": "Este será el nombre usado para identificar tu empresa con tus socios",
  "Select Country": "Seleccionar país",
  "Select Material": "Seleccionar material",
  "Select material type": "Seleccionar tipus de material",
  "Select MaterialType": "Seleccionar material",
  "Select Role": "Seleccionar rol",
  "Select stage": "Seleccionar una etapa",
  "Select Type": "Seleccionar tipus",
  "Select Unit": "Seleccionara unitat",
  "Select actions": "Seleccionar accions",
  "Select all": "Seleccionar tot",
  "Select action": "Seleccionara acció",
  "Select Columns": "Seleccionar columnes",
  "Select inks type": "Seleccionar el tipus de tintes",
  "Select or drag and drop in the box below the new file that you want to upload": "Seleccionar o arrossegua i deixa anar al quadre de sota del nou fitxer que vols carregar",
  "Select units type": "Seleccionaritats",
  "select-a-workflow": "Seleccionar flux de treball",
  "select-services": "Seleccionar Serveis",
  "select-status": "Seleccionar estat",
  "Send": "Enviar",
  "Send an email to any email address specified": "Envia un correu electrònic a qualsevol adreça de correu electrònic especificada",
  "Send to partner": "Enviar al soci",
  "Some items failed to send": "Alguns elements no s'han pogut enviar: {successful}/{total} exitosos",
  "Order items sent to partner": "Elements enviats al soci: {successful}/{total} exitosos",
  "Failed to send order items to partner": "Error en enviar elements al soci",
  "send-email-to-address": "Enviar correu electrònic als destinataris",
  "send-email-to-items-owner": "Envia un correu electrònic al propietari de l'ítem",
  "send-email-to-owner": "Enviar correu electrònic al propietari",
  "Services": "Serveis",
  "Services saved successfully": "Serveis desats correctament",
  "set": "establert",
  "settings": "Configuració",
  "Show Archived": "Mostrar arxivats",
  "Showing X results": "Mostrant 0 resultats|Mostrant 1 resultat|Mostrant {count} resultats",
  "SignUp": "Registra't",
  "Silk": "Seda",
  "Skip this step. I will add workers later": "Ometre aquest pas. Afegiré treballadors Més endavant.",
  "Sku": "SKU",
  "Something went wrong Please try again later": "Alguna cosa ha anat malament. \nSi us plau, intenta-ho més tard.",
  "something-went-wrong-please-try-again-later": "Alguna cosa ha anat malament. \nSi us plau, intenta-ho més tard.",
  "Split to new order": "Dividir en una nova ordre",
  "Stage created successfully": "Etapa creada amb èxit",
  "Stage deleted successfully": "L'etapa s'ha suprimit correctament",
  "Stage updated successfully": "L'etapa s'ha actualitzat correctament",
  "start": {
    "title1": "La manera més senzilla de connectar marques de disseny amb centres d'impressió",
    "title2": "Inèdit Connect és la forma més fàcil, ràpida i fiable de rebre, gestionar i enviar comandes d'impressió amb els teus clients.",
    "description": "Una {0} per solucionar el buit {1} o marques i {2}.",
    "description2": "Aquesta plataforma té com a objectiu revolucionar la forma en què abordem la fabricació, proporcionant un {0} per a la {1}."
  },
  "Started": "Començat",
  "Starts with": "Comença amb",
  "State": "Província",
  "Statistics": "Estadístiques",
  "Status": "Estat",
  "Stock Available": "Stock disponible",
  "Street": "Carrer",
  "strong": "Fort",
  "submit": "Enviar",
  "suggestions": "Suggeriments",
  "Surname": "Cognom",
  "Tell us how was the experience with your partner": "Explica'ns com ha sigut l'experiència amb el teu soci",
  "terms": "Termes",
  "There are no items for this order please add new items with the button below": "No hi ha articles per a aquesta ordre, si us plau, afegeix nous articles amb el següent botó",
  "There should be at least one Admin user": "Hi ha d'haver almenys un usuari administrador",
  "There was an error creating the InkType": "S'ha produït un error en crear el tipus de tinta",
  "There was an error creating the MaterialType": "S'ha produït un error en crear el material",
  "There was an error creating the Order": "S'ha produït un error creant l'ordre",
  "There was an error deleting order": "S'ha produït un error en suprimir l'ordre",
  "There was an error deleting the comment": "S'ha produït un error en suprimir el comentari",
  "There was an error deleting the InkType": "S'ha produït un error en suprimir el tipus de tinta",
  "There was an error deleting the MaterialType": "S'ha produït un error en suprimir el material",
  "There was an error deleting the Printer": "S'ha produït un error en suprimir la impressora",
  "There was an error downloading the PDF": "S'ha produït un error descarregant el PDF",
  "There was an error editing the": "S'ha produït un error en editar el ",
  "There was an error moving the ítem": "S'ha produït un error en moure l'ítem",
  "There was an error moving the order": "S'ha produït un error en moure l'ordre",
  "There was an error saving the services": "S'ha produït un error desant els serveis",
  "There was an error updating the Material": "S'ha produït un error en actualitzar el material",
  "There was an error updating the MaterialType": "S'ha produït un error en actualitzar el material",
  "There was an error verifying the access token": "S'ha produït un error en verificar el clau d'accés",
  "there-was-an-error-creating-the-user": "S'ha produït un error en crear l'usuari",
  "there-was-an-error-deleting-the-ítem": "S'ha produït un error en suprimir l'element",
  "third": {
    "title": "Finalment, afegeix alguns treballadors de la teva empresa",
    "description": "Podran veure i gestionar el flux de treball d'impressió de la teva empresa."
  },
  "otp": {
    "title": "Verifica el teu correu electrònic",
    "description": "Hem enviat un codi de verificació a",
    "verify": "Verificar",
    "resend": "Reenviar codi"
  },
  "This is a test": "Això és un test",
  "This will be the name used to connect with partners": "Aquest serà el nom utilitzat per connectar amb els socis",
  "this-month": "Aquest mes",
  "this-quarter": "Aquest trimestre",
  "this-year": "Aquest any",
  "to": "a",
  "to-confirm-please-write-delete-on-the-box-below": "Per confirmar, si us plau, escriu DELETE al quadre següent",
  "Total": "Total",
  "today": "Avui",
  "token_warning": "Aquesta clau només es mostrarà una vegada. Si us plau, copieu-la i Desa-la en un lloc segur.",
  "TShirt": "Samarreta",
  "TShirt Red": "Samarreta vermella",
  "Tulle": "Tul",
  "Type": "Tipus",
  "Unblock": "Desbloqueja",
  "Undefined": "Sense definir",
  "Unit": "Unitat",
  "Units": "Unitats",
  "Units of measure": "Unitats de mesura",
  "units-required": "Les unitats són necessàries",
  "Unsaved changes": "Canvis no desats",
  "Unstarted": "Sense començar",
  "upcoming-due": "Data de venciment pròxima o caducada",
  "uploaded-at": "Pujat a les",
  "URL": "URL",
  "User": "Usuari",
  "User already exists with": "L'usuari ja existeix amb",
  "User email must be unique": "El correu electrònic ha de ser únic",
  "Users": "Usuaris",
  "Users deleted successfully": "L'usuari s'ha eliminat correctament|{count} usuaris s'han eliminat correctament",
  "users-by-company": "Usuaris per empresa",
  "UUID": "UUID",
  "validations": {
    "alphaNum": "El valor només pot contenir lletres i números.",
    "maxLength": "El camp {property} ha de tenir una longitud màxima de {max}.",
    "minLength": "El camp {property} ha de tenir una longitud mínima de {min}.",
    "required": "El camp {property} és obligatori."
  },
  "Value is not a valid email address": "El valor no és una adreça electrònica vàlida",
  "Value is required": "El valor és obligatori",
  "View": "Veure",
  "VIEW": "VEURE",
  "View/Edit": "Veure/Editar",
  "we-have-detected-that-you-dont-belong-to-any-company": "Hem detectat que no pertanys a cap empresa, pots crear-ne una de nova o demanar a un administrador de l'empresa que et convidi",
  "we-have-sent-you-an-email-with-instructions-to-delete-your-company-and-all-your-data": "T'hem enviat un correu electrònic amb instruccions per eliminar la teva empresa i totes les dades.",
  "Weak": "Dèbil",
  "Welcome Back": "Benvingut de nou",
  "Width": "Amplada",
  "Workflow": "Fluxe de treball",
  "Workflow deleted": "Fluxe de treball eliminat",
  "Workflow saved": "S'ha guardat el fluxe de treball",
  "Workflow Stage": "Etapa",
  "Workflow Stages": "Etapes del flux de treball",
  "workflow-stage": "etapa",
  "Workflows": "Fluxos de treball",
  "workflowStages_description": "Pots personalitzar fàcilment els teus fluxos de treball afegint noves etapes. \nNomés has d'introduir el nom, la descripció i l'ordre de cada etapa. \nAixò proporciona flexibilitat i adaptabilitat, permetent crear fluxos de treball que s'adaptin a les teves necessitats úniques i millorar la productivitat.",
  "Workstation": "Estació de treball",
  "Write a review": "Escriu una ressenya",
  "Write your comments here": "Escriu els teus comentaris aquí...",
  "x-columns-selected": "{count} columnes seleccionades",
  "x-items-selected": "{count} elements seleccionats",
  "Yards": "Iardes",
  "Yes": "Sí",
  "Yesterday": "Ahir",
  "You": "Tu",
  "You are not authorized to perform this action": "No estàs autoritzat per dur a terme aquesta acció",
  "you-are-not-connected-to-the-internet-verify-your-connection-and-then-try-again": "No estàs connectat a Internet. \nVerifica la teva connexió i torneu-ho a provar.",
  "you-dont-have-permission-to-perform-this-action": "No tens permís per dur a terme aquesta acció",
  "you-have-changed-field-to-new": "has {verb} {field} a {value}|{name} has {verb} {field} a {value}|{name} ha {verb} {field} a {value}",
  "you-have-unsaved-changes-do-you-want-to-save-or-continue-losing-your-changes": "Tens canvis no desats. \nVols desar o continuar sense desar els teus canvis?",
  "Your name": "El teu nom",
  "Zip": "Codi Postal",
  "Zip Code": "Codi postal",
  "Partner": "Soci",
  "Partner Material SKU": "SKU del soci",
  "material-name-partner": "Nom del material del soci",
  "Deleted": "Suprimit",
  "MaterialType has materials associated with it": {},
  "Cannot delete this Material Type because it has materials associated with it": "No es pot suprimir aquest tipus de material perquè té materials associats",
  "Cannot delete this Material because it has order items associated with it": "No es pot suprimir aquest material perquè té ítems d'ordre associats",
  "select-your-company": "Seleccionar la teva empresa",
  "we-have-detected-that-you-belong-to-more-than-one-company-please-choose-the-company-you-wish-to-log-in-with": "Hem detectat que pertanys a més d'una empresa. \nSi us plau, tria l'empresa amb la qual vols iniciar sessió.",
  "Material already exists with": "Ja existeix un material amb",
  "Sort order": "Ordre d'ordenació",
  "Sort by": "Ordenar per",
  "Any": "Qualsevol",
  "Order items moved to stage": "Ítems moguts a l'etapa",
  "Role is required": "Es requereix un rol",
  "units-are-required": "Les unitats són requerides",
  "Select partner": "Seleccionar un soci",
  "select-sorting-method": "Seleccionar mètode d'ordenació",
  "Encrypted": "Xifrat",
  "Outgoing Orders": "Ordres sortints",
  "Job": "Treball",
  "Encrypt jobs": "Xifrar treballs",
  "Encrypt outgoing jobs before sending them to your partner": "Xifrar els treballs sortints abans d'enviar-los al teu soci",
  "Send the item file as it is": "Enviar el fitxer de l’ítem tal com està",
  "Send ": {
    "xjb jobs instead of files": "Enviar treballs .xjb en lloc de fitxers"
  },
  "Third Party Licenses": "Llicències de tercers",
  "resolution-x": "Resolució X",
  "resolution-y": "Resolució Y",
  "Height": "Alçada",
  "Profile": "Perfil",
  "num-channels": "Núm. Canals",
  "num-colorways": "Núm. Colorits",
  "No image file. Please request the partner to upload the image again.": "No hi ha cap fitxer. Si us plau, demaneu al soci que torni a carregar el fitxer.",
  "file_size_exceeded": "El fitxer {name} supera el límit de mida de {size} MB",
  "file_type_not_allowed": "No es permet el tipus de fitxer \"{type}\"",
  "There is no maximum": "No hi ha màxim",
  "All the extensions": "Totes les extensions",
  "Configuration": "Configuració",
  "Allowed file extensions": "Extensions de fitxer permeses",
  "maximum-file-size-in-megabytes-mb": "Mida màxima del fitxer en megabytes (MB)",
  "configuration-updated": "Configuració actualitzada",
  "error-updating-configuration": "S'ha produït un error en actualitzar la configuració",
  "Manage services": "Gestionar els serveis",
  "Ratings": "Ressenyes",
  "Reviews": "Ressenyes",
  "Third-party licenses": "Llicències de tercers",
  "third-party-licenses-description": "Hola! \nNomés volia fer-vos saber que hem estat utilitzant llibreries i eines de tercers increïbles per ajudar-nos a desenvolupar el nostre programari. \nAquestes llicències de codi obert han estat una gran ajuda per fer que el nostre projecte sigui més eficient i robust. \nEstem molt agraïts pel treball dur i la dedicació dels desenvolupadors que van crear aquestes eines, i estem encantats de seguir utilitzant-les per millorar encara més el nostre projecte!",
  "third-party-software-that-is-part-of-the-web-application": "Programari de tercers que forma part de l'aplicació web:",
  "file-too-large": "Mida del fitxer no vàlida, la mida del fitxer hauria de ser inferior a {maxSize} MB.",
  "Primary": "Principal",
  "Surface": "Superfície",
  "Encrypted in the partner": "Encriptat al soci",
  "Pending information": "Informació pendent",
  "Table": "Taula",
  "Compact cards": "Targetes compactes",
  "Full sized cards": "Targetes a mida completa",
  "Custom Fields": "Camps personalitzats",
  "Custom Dialogs": "Diàlegs personalitzats",
  "add-custom-field": "Afegeix un camp personalitzat",
  "field-type": "Tipus de camp",
  "text": "text",
  "Label": "Etiqueta",
  "Text": "Text",
  "Boolean": "Booleà ",
  "Options": "Opcions",
  "insert-field-available-options": "Escriu i prem 'Entrar' per afegir cada opció",
  "custom-field-deleted": "Camp personalitzat eliminat",
  "error-deleting-custom-field": "Error en eliminar el camp personalitzat",
  "Multiselect": "Selecció múltiple",
  "Dropdown": "Menú desplegable",
  "default-value": "Valor per defecte",
  "manage-custom-dialogs": "Gestioneu els diàlegs personalitzats",
  "add-custom-dialog": "Afegeix un diàleg personalitzat",
  "dialog-title": "Títol del diàleg",
  "Title": "Títol",
  "this-title-will-be-shown-on-the-dialog-header": "Aquest títol es mostrarà a la capçalera del diàleg",
  "No Status": "Sense estat",
  "No Material": "Sense material",
  "remove-all-filters": "Elimina tots els filtres",
  "do-you-want-to-delete-this-item": "Vols suprimir aquest element?",
  "Fields": "Camps",
  "Required": "Obligatori",
  "Read only": "Només lectura",
  "TextArea": "Àrea de text",
  "delete-question": "Suprimir?",
  "this-cant-be-undone": "Aquest canvi no es pot desfer",
  "add-new-filed": "Afegeix un nou fitxer",
  "select-a-field": "Seleccionar camp",
  "Custom fields": "Camps personalitzats",
  "Entity": "Entitat",
  "order-new-custom-field": "ordre-nou-camp-personalitzat",
  "new-custom-field": "Nou camp personalitzat",
  "New Custom Field": "Nou camp personalitzat",
  "custom-field-saved": "El camp personalitzat s'ha desat correctament",
  "custom-dialog-saved": "S'ha desat el diàleg personalitzat",
  "custom-dialog-save-error": "S'ha produït un error en desar el diàleg personalitzat",
  "Custom field saved": "S'ha desat el camp personalitzat",
  "error-saving-custom-field": "S'ha produït un error en desar el camp personalitzat",
  "Su": "Dg",
  "Mo": "Dl",
  "Tu": "Dt",
  "We": "Dc",
  "Th": "Dj",
  "Fr": "Dv",
  "Sa": "Ds",
  "January": "Gener",
  "February": "Febrer",
  "March": "Març",
  "April": "Abril",
  "May": "Maig",
  "June": "Juny",
  "July": "Juliol",
  "August": "Agost",
  "September": "Setembre",
  "October": "Octubre",
  "November": "Novembre",
  "December": "Desembre",
  "error-deleting-users": "Error en suprimir l'usuari|Error en suprimir usuaris",
  "or-login": "O inicia sessió",
  "project": "Projecte",
  "about-us": "Qui som",
  "no-available-options": "No hi ha opcions disponibles",
  "user-created-successfully": "Usuari creat correctament",
  "Rejected": "Rebutjat",
  "Disable job": "Treball deshabilitat",
  "Print end": "Impressió finalitzada",
  "Print End": "Impressió acabada",
  "error-deleting": "Error al suprimir",
  "deleted-successfully": "S'ha suprimit correctament",
  "Filter": "Filtrar",
  "Ascending": "Ascendent",
  "Descending": "Descendent",
  "select-order": "Seleccionar ordre",
  "show-expired": "Mostrar caducats",
  "show-expired-files": "Mostra els fitxers caducats",
  "error-resetting-custom-dialog": "S'ha produït un error en restablir el diàleg personalitzat",
  "custom-dialog-has-values": "Hi ha valors establerts per als camps personalitzats d'aquest diàleg",
  "together": "junts",
  "lets-print": "Imprimim {0}!",
  "apply-to-all": "Aplicar a tots",
  "Catalan": "Català",
  "Spanish": "Espanyol",
  "English": "Anglès",
  "Italian": "Italià",
  "search-by-material": "Cerca per material",
  "no-materials-found": "No s'han trobat materials",
  "data-use-policy": "Política d'ús de dades",
  "cookies-use": "Ús de cookies",
  "drop-files-here-to-create-a-new-order": "Deixa anar fitxers aquí per crear una ordre nova",
  "drop-files-here": "Deixa anar fitxers aquí",
  "drop-files-here-default-order": "Deixa anar fitxers aquí per a una ordre predeterminada",
  "Show less": "Mostra menys",
  "Show more": "Mostra'n més",
  "No information available": "No hi ha informació disponible",
  "Page height": "Alçada de la pàgina",
  "Page width": "Amplada de la pàgina",
  "order-item-moved-to-stage-name-successfully": "L'ítem s'ha mogut correctament a l'etapa \"{name}\"",
  "send-it-again": "torna'l a enviar",
  "Move to workflow": "Moure al flux de treball",
  "Sunday": "Diumenge",
  "Monday": "Dilluns",
  "Tuesday": "Dimarts",
  "Wednesday": "Dimecres",
  "Thursday": "Dijous",
  "Friday": "Divendres",
  "Saturday": "Dissabte",
  "Sun": "Dg.",
  "Mon": "Dl.",
  "Tue": "Dt",
  "Wed": "Dc.",
  "Thu": "Dj.",
  "Fri": "Dv.",
  "Sat": "Ds.",
  "Jan": "Gen",
  "Feb": "Feb",
  "Mar": "Mar",
  "Apr": "Abr",
  "Jun": "Jun",
  "Jul": "Jul",
  "Aug": "Ago",
  "Sep": "Set",
  "Oct": "Oct",
  "Nov": "Nov",
  "Dec": "Des",
  "add-order-type": "Afegir tipus d'ordre",
  "order-type-stage": "Etapa per defecte",
  "are-you-sure": "Estas segur?",
  "delete-order-type": "Suprimeix el tipus d'ordre",
  "are-you-sure-you-want-to-delete-this-order-type": "Estas segur que vols suprimir aquest tipus d'ordre?",
  "you-have-unsaved-changes-if-you-leave-now-you-may-lose-yor-changes-are-you-sure-you-want-to-leave": "Tens canvis no desats. \nSi marxes ara, pots perdre canvis, segur que vols sortir?",
  "Order Type": "Tipus d'ordre",
  "commmunity-platform": "plataforma comunitària",
  "between-designers": "entre dissenyadors",
  "printer-mills": "centres d'impressió",
  "follow-us": "Segueix-nos",
  "centrilized-hub": "centre de connexió",
  "collaboration-communication-and-creativity": "col·laboració, comunicació i creativitat",
  "id": "Id",
  "order": "Ordre",
  "UpdatedAt": "Actualització",
  "CurrentFile": "Fitxer actual",
  "OrderId": "Id de l'ordre",
  "Line": "Línia",
  "WorkflowStageId": "Id de l'etapa del flux de treball",
  "ParentId": "Id de l'ordre pare",
  "CurrentFileId": "Id de fitxer actual",
  "Position": "Posició",
  "Order Types": "Tipus d'ordre",
  "manage-company-and-services-in-administration": "Gestionar l'empresa i els serveis a l'administració",
  "manage-orders-in-workflows-view": "Gestionar les comandes a la vista de fluxos de treball",
  "manage-roles-and-permissions-in-administration": "Gestionar \"rols i permisos\" a l'administració",
  "manage-materials-in-administration": "Gestionar materials en l'administració",
  "manage-users-in-administration": "Gestiona els usuaris a l'administració",
  "manage-workflows-in-administration": "Gestionar els fluxos de treball a l'administració",
  "manage-partners-in-administration-also-manage-partners-in-partners-discovery": "Gestionar els socis en l'administració. \nTambé gestiona els socis en \"descobrir socis\"",
  "manage-activity-history-of-the-orders-in-workflows-view": "Gestionar l’historial d’activitats de les ordres a la vista de fluxos de treball",
  "information-not-available-for-this-entity": "Informació no disponible per a aquesta entitat",
  "Checkbox": "Casella de selecció",
  "Repetitions": "Repeticions",
  "propagate-units-to-all-items": "Propagar unitats a tots els ítems",
  "default-workflow-stage-for-incoming-orders-cant-be-a-partners-stage": "L'etapa de flux de treball per defecte per a comandes entrants no pot ser una etapa de tipus \"socis\"",
  "Developers": "Desenvolupadors",
  "layouts": "Plantilles",
  "no-layouts-found": "No s'ha trobat plantilles",
  "new-layout": "Nova Plantilla",
  "layout-name-placeholder": "Nova plantilla",
  "choose-file": "Triar Arxiu",
  "upload-layout-file": "Pujar el fitxer de la plantilla",
  "upload-layouts-individually-in-bulk-or-as-a-zip-archive-any-files-with-matching-names-will-be-automatically-updated-with-your-new-versions": "Carrega dissenys individualment o múltiples fitxers. \nQualsevol fitxer existent amb noms coincidents s’actualitzarà automàticament amb la nova versió.",
  "Upload files": "Pujar fitxers",
  "Upload": "Penjar",
  "Preparing files": "Preparant fitxers",
  "Error": "Error",
  "default-layout": "Plantilla per defecte",
  "default-layout-description": "Aquesta plantilla s'aplicarà a l'ordre quan es crei el fitxer de treball",
  "Layout": "Plantilla",
  "Layout applied": "Disseny aplicat",
  "Layout selected": "Plantilla seleccionada",
  "Number of pages": "Nombre de pàgines",
  "number-of-inputs": "Nombre d'imatges",
  "allowed-users": "Usuaris permesos",
  "Visible": "Visible",
  "layout-updated-successfully": "Plantilla actualitzada amb èxit",
  "attachments": "Adjunts",
  "show-attachments": "Mostrar fitxers adjunts",
  "layout-cant-be-changed-after-the-order-has-been-created": "La plantilla no es pot canviar després d'haver creat l'ordre",
  "error-accepting-order": "Error acceptant l'ordre",
  "order-type-cant-be-changed-after-the-order-has-been-created": "El tipus d'ordre no es pot modificar després de la creació de l'ordre",
  "Layouts": "Plantilles",
  "users-and-access": "Usuaris i accés",
  "Organization": "Organització",
  "system-configuration": "Configuració del sistema",
  "workflow-&-orders": "Fluxos de treball i ordres",
  "Resources": "Recursos",
  "error-saving-the-stage": "Error en guardar l'etapa",
  "stage-saved-successfully": "Etapa desat correctament",
  "Workflow already exists with same name": "Ja existeix un flux de treball amb el mateix nom",
  "accept_partnership": {
    "description": "Ara sou socis de {company}."
  },
  "Already partners": "Ja és soci",
  "verification-email-sent": "Correu electrònic de verificació enviat",
  "verification-email-description": "Si us plau, comproveu la vostra safata d'entrada i feu clic a l'enllaç de verificació per activar el teu compte. Aquest pas és necessari per completar el teu registre i accedir a totes les funcions.",
  "mail_not_received_verification": "No has rebut l'email? Comprova la teva carpeta de correu brossa",
  "user-account-not-verified": "Compte d'usuari no verificat",
  "sorry-this-user-email-has-not-been-verified-please-check-your-inbox-for-the-verification-email": "Ho sentim, aquest correu electrònic d'usuari no s'ha verificat. Si us plau, comproveu la vostra safata d'entrada per al correu de verificació.",
  "company-is-not-active": "L'empresa no està activa",
  "sorry-the-company-you-are-trying-to-access-is-not-active-please-contact-your-company-administrator": "Ho sentim, l'empresa a la qual intentes accedir no està activa. Si us plau, espera fins que el nostre equip de vendes validi aquest compte.",
  "default-workflow-description": "Quan es crei una ordre, es posarà automàticament en aquest flux de treball",
  "Optimize jobs": "Optimitzar treballs",
  "some-file-types-are-not-compatible-with-layouts": "Alguns tipus de fitxers no són compatibles amb la plantilla",
  "supported-file-types-are": "Els tipus de fitxers admesos són",
  "file-type-is-not-supported-in-layouts": "El tipus de fitxer no és compatible amb la plantilla",
  "failed-to-delete-order-items": "No s'han pogut eliminar els elements de l'ordre",
  "cant-delete-item-because-it-has-children": "No es pot eliminar l'element perquè ha estat acceptat per un soci.",
  "selected-items": "elements seleccionats",
  "an-order-with-status-accepted-cannot-be-moved": "No es pot moure una ordre amb l'estat \"Acceptada\".",
  "Cannot do this action because at least one item it has been sent to a partner": "No es pot fer aquesta acció perquè almenys una ordre s'ha enviat a un soci",
  "there-was-an-error-loading-the-order-items": "Hi ha hagut un error en carregar els elements.",
  "Created by": "Creat per",
  "Created By": "Creat per",
  "Customers": "Clients",
  "Phone": "Telèfon",
  "new-customer": "Nou client",
  "are-you-sure-you-want-to-delete-this-customer": "Esteu segur que voleu eliminar aquest client?",
  "customer-deleted-successfully": "El client s'ha eliminat correctament",
  "send-a-webhook-to-specified-url": "Envia un webhook a l'URL especificada",
  "send-webhook": "Enviar webhook",
  "enter-webhook-url": "Introdueix l'URL del webhook",
  "Webhook sent": "Webhook enviat",
  "Error sending webhook": "Error enviant el webhook",
  "Request failed with status code 404": "La sol·licitud ha fallat amb el codi d'estat 404: No s'ha trobat",
  "webhook-url-is-required": "Es requereix l'URL del webhook",
  "pre-process-layout": "Preprocessar plantilla",
  "pre-process-layout-description": "Seleccionat, es preprocessarà la plantilla al núvol per generar un treball abans d'enviar a imprimir. Si no es selecciona, la plantilla s'aplicarà després de ser enviat a l'impressora. ",
  "Printer": "Impressora",
  "Scheme": "Esquema",
  "Print automatically": "Imprimir auto",
  "search-by-customer": "Cerca per client",
  "search-by-layout": "Cerca perplantilla",
  "search-by-scheme": "Cerca per esquema",
  "search-by-printer": "Cerca per impressora",
  "item": "Element",
  "select-printer": "Seleccionar la impressora",
  "select-scheme": "Seleccionar l'esquema",
  "pages": "pàgina|pàgines",
  "images": "imatge|imatges",
  "removed": "eliminat",
  "removed-field": "s'ha eliminat {field}|{name} has eliminat {field}|{name} ha eliminat {field}",
  "Batch created successfully": "El lot {batchNumber} s'ha creat correctament",
  "Failed to create batch": "No s'ha pogut crear el lot",
  "Cannot create batch with items that already belong to another batch": "No es pot crear un lot amb elements que ja pertanyen a un altre lot",
  "Create a batch": "Crear un lot",
  "Manage batch": "Gestionar lot",
  "Cannot mix items with and without batch. Select only items without batch to create, or only items with batch to manage.": "No es poden barrejar elements amb i sense lot. Selecciona només elements sense lot per crear, o només elements amb lot per gestionar.",
  "Create a new batch with selected items": "Crear un nou lot amb els elements seleccionats",
  "Add selected items to an existing batch": "Afegir elements seleccionats a un lot existent",
  "Remove selected items from their batches": "Eliminar elements dels seus lots",
  "Remove from batch {batchNumber}": "Eliminar del lot {batchNumber}",
  "Remove from batches {batchNumbers}": "Eliminar dels lots {batchNumbers}",
  "No items without batch to create batch": "No hi ha elements sense lot per crear lot",
  "No items without batch to add": "No hi ha elements sense lot per afegir",
  "No items with batch to remove": "No hi ha elements amb lot per eliminar",
  "Items added to batch successfully": "Elements afegits al lot correctament",
  "Items removed from batch successfully": "Elements eliminats del lot correctament",
  "Failed to manage batch": "Error al gestionar el lot",
  "No batch selected": "Cap lot seleccionat",
  "Items from different batches": "Elements de diferents lots",
  "Batches: {batchNumbers}": "Lots: {batchNumbers}",
  "Selected items belong to different batches. They will be removed from their current batches.": "Els elements seleccionats pertanyen a diferents lots. S'eliminaran dels seus lots actuals.",
  "the batch number": "el número de lot",
  "Next batch number": "Número de lot següent",
  "Last batch created": "Últim lot creat",
  "Must be greater than": "Ha de ser més gran que",
  "Preprocess layout": "Disseny de preprocés",
  "status": "estat",
  "edit-n-items": "Edita 1 element|Edita {n} elements",
  "edit-n-jobs": "Edita 1 treball|Edita {n} treballs",
  "width-units": "Unitats d'amplada",
  "Multiple": "Múltiples",
  "none": "Cap",
  "MULTIPLE_VALUES_INDICATOR": "Múltiples",
  "there-was-an-error-editing-the-order-items": "Hi ha hagut un error editant els elements",
  "order-items-updated-successfully": "Elements actualitzats correctament",
  "search-by-email": "Cerca per correu electrònic",
  "search-by-phone": "Cerca per telèfon",
  "search-by-state": "Cerca per estat",
  "print_progress": "Progrés d'impressió",
  "search-by-zip": "Cerca per codi postal",
  "search-by-address": "Cerca per adreça",
  "Disable_job": "Desactiva la feina",
  "Do you want to split this item? A new order with _split suffix will be created": "Vols dividir aquest ítem? Es crearà una nova ordre amb el sufix _split|Vols dividir aquests ítems? Es crearà una nova ordre amb el sufix _split",
  "Error while archiving order item": "Error mentre s'arxiva l'element de l'ordre",
  "Order item archived successfully": "L'element de l'ordre s'ha arxivat correctament",
  "Order item has been archived": "L'element de l'ordre s'ha arxivat",
  "Partner Mat": {
    " SKU": "Soci"
  },
  "There was an error moving the item": "Hi ha hagut un error en moure l'element.",
  "USER": "Usuari",
  "back-to-login": "Torna a l'inici de sessió",
  "disable_job": "Desactiva la feina",
  "enable_job": "Habilita la feina",
  "hey-there-just-wanted-to-let-you-know-that-weve-been-using-some-awesome-third-party-libraries-and-tools-to-help-us-develop-our-software-these-open-source-licenses-have-been-a-huge-help-in-making-our-project-more-efficient-and-effective-were-super-grateful-for-the-hard-work-and-dedication-of-the-developers-who-created-these-tools-and-were-excited-to-keep-using-them-to-make-our-project-even-better": "Ei! Només volia fer-vos saber que hem estat utilitzant algunes llibreries i eines de tercers fantàstiques per ajudar-nos a desenvolupar el nostre programari. Aquestes llicències de codi obert han estat d'una gran ajuda per fer el nostre projecte més eficient i efectiu. Estem molt agraïts pel treball dur i la dedicació dels desenvolupadors que han creat aquestes eines, i estem emocionats de continuar utilitzant-les per millorar encara més el nostre projecte!",
  "in-queue": "A la cua",
  "internal-use-field": "Camp d'ús intern, no es pot modificar",
  "mailPlaceholder": "Per exemple, nom{'@'}empresa.com",
  "print_start": "Inicia impressió",
  "search-by-city": "Cerca per ciutat",
  "search-by-country": "Cerca per país",
  "select-date": "Seleccionar la data",
  "select-material": "Seleccionar material",
  "there-was-an-error-deleting-the-item": "Hi ha hagut un error en eliminar l'element",
  "there-was-an-error-downloading-the-file": "Hi ha hagut un error en descarregar el fitxer.",
  "there-was-an-error-fetching-the-layouts": "Hi ha hagut un error en obtenir les plantilles",
  "View all": "Veure tot",
  "by-material": "Per material",
  "by-due-date": "Per data de venciment",
  "by-creation-date": "Per data de creació",
  "by-batch": "Per lots",
  "by-customer": "Pel client",
  "by-order-type": "Per tipus d'ordre",
  "Buckets": "Agrupacions",
  "Batch": "Lot",
  "By": "Per",
  "customer": "client",
  "orderType": "tipus d'ordre",
  "date": "data",
  "creationDate": "data de creació",
  "without-material": "Sense material",
  "search-by-order-type": "Cerca Per tipus d'ordre",
  "Without": "Sense",
  "this-week": "Aquesta setmana",
  "old": "Vençudes",
  "rest": "Futures",
  "batch": "lot",
  "no-due-date": "Sense data de venciment",
  "next-week": "La setmana vinent",
  "tomorrow": "Demà",
  "Search by batch": "Cerca per lot",
  "selected-n-length": "{n} {units} seleccionats",
  "Cards": "Targetes",
  "List": "Llista",
  "total-items": "Total d'articles",
  "total-length": "Longitud total",
  "quantity": "quantitat",
  "the quantity": "la quantitat",
  "the width": "l'amplada",
  "the length": "la longitud",
  "the widthUnits": "les unitats d'amplada",
  "the lengthUnits": "les unitats de longitud",
  "the material": "el material",
  "the workflowStage": "l'etapa del flux de treball",
  "the printer": "la impressora",
  "the scheme": "l'esquema",
  "the layout": "la plantilla",
  "There are no schemes configured for this printer": "No hi ha cap esquema configurat per a aquesta impressora",
  "Uploads": "Càrregues",
  "Clear all": "Esborra-ho tot",
  "No uploads": "No hi ha càrregues",
  "Some order items already have a batch": "Alguns elements del bucket ja pertanyen a un lot.",
  "create-a-batch-with-n-elements-for-this-bucket": "Crea un lot amb {n} element per aquest bucket?|Crea un lot amb {n} elements per aquest bucket?",
  "Path": "Ruta",
  "Select layout": "Seleccionar plantilla",
  "Select customer": "Seleccionar client",
  "select-a-user": "Seleccionar usuari",
  "Order ID": "ID Ordre",
  "Item ID": "ID Item",
  "download-pdf": "Descarregar PDF",
  "Split PDF": "Dividir PDF",
  "pdf-has-n-pages-split-question": "El PDF \"{name}\" té {count} pàgines. Vols dividir cada pàgina en un ítem separat?",
  "Split into separate items": "Dividir en ítems separats",
  "Keep as single item": "Mantenir com un sol ítem",
  "Select pages to import": "Seleccionar pàgines per importar",
  "Grid view": "Vista de graella",
  "List view": "Vista de llista",
  "n-pages-selected": "{count} de {total} pàgines seleccionades|{count} de {total} pàgines seleccionades",
  "Import": "Importar",
  "Loading previews...": "Carregant vistes prèvies...",
  "Connected Devices": "Dispositius connectats",
  "connect-with-qr-reader": "Connecta't amb el lector de QR",
  "2-open-the-app-go-to-setting-click-on-add-button-and-scan-the-qr-code": "2. Obre l'aplicació, ves a Configuració, fes clic al botó '+' i escaneja el codi QR",
  "1-download-the-qr-reader-app": "1. Descarrega l'aplicació QR Reader",
  "move-to-next-stage": "Moure a la següent etapa",
  "view-order": "Veure ordre",
  "view-batch": "Veure lot",
  "the currentFile": "el fitxer",
  "destination": "Destinació",
  "printer": "Impressora",
  "Website": "Lloc web",
  "Social Networks": "Xarxes Socials",
  "Choose platform": "Tria la plataforma",
  "Choose a platform": "Tria una plataforma",
  "URL completa": "URL complet",
  "Network name": "Nom de la xarxa",
  "Link with user": "Enllaç / {'@'}usuari",
  "View website": "Veure pàgina web",
  "Other social network": "Altres xarxes socials",
  "No social networks added": "No s'han afegit xarxes socials",
  "Add social network": "Afegeix una xarxa social",
  "yourusername": "elteuusuari",
  "edit-1-item": "Edita 1 element",
  "Export": "Exporta",
  "change-action": "Canvia acció",
  "multiple-values": "Valors múltiples",
  "Printer-updated-successfully": "La impressora s'ha actualitzat correctament",
  "There-was-an-error-updating-the-layout": "Hi ha hagut un error actualitzant la plantilla",
  "There-was-an-error-updating-the-printer": "S'ha produït un error en actualitzar la impressora",
  "Are-you-sure-delete-printers": "Esteu segur que voleu suprimir les impressores seleccionades?",
  "Are-you-sure-delete-printer": "Esteu segur que voleu suprimir la impressora seleccionada?",
  "Printers deleted successfully": "Les impressores s'han suprimit correctament",
  "There-was-an-error-deleting-the-printers": "S'ha produït un error en suprimir les impressores",
  "Materials deleted successfully": "Els materials s'han suprimit correctament",
  "There-was-an-error-deleting-the-materials": "S'ha produït un error en suprimir els materials",
  "Are-you-sure-delete-material": "Esteu segur que voleu suprimir el material seleccionat?",
  "Are-you-sure-delete-materials": "Esteu segur que voleu suprimir els materials seleccionats?",
  "Loading layouts data": {
    " Please wait": "Càrrega de dades de dissenys. \nSi us plau, espereu"
  },
  "Connect-your-device-to-scan-QR": "Connecta el teu dispositiu per escanejar codis QR dels PDF i ves directament a la pàgina d'acció de l'element.",
  "Files": "Fitxers",
  "Batches": "Lots",
  "Export PDF": "Exporta PDF",
  "end-date": "Data de finalització",
  "aborted-date": "Data d'interrupció",
  "Done Items": "Elements completats",
  "jobs": "treball|treballs",
  "send-to-printer": "Enviar a la impressora",
  "move-to-printer": "Moure a la impresora",
  "Print Jobs": "Treballs d'impressió",
  "Update Date": "Data d'actualització",
  "select-order-type": "Seleccionar el tipus d'ordre",
  "select-batch": "Seleccionar el lot",
  "search-by-batch": "Cerca per lot",
  "cannot-edit-layout-when-in-printers-or-done-stage": "No es pot editar la plantilla en les etapes de tipus 'Impressores' ni en les del grup 'Acabat'",
  "cannot-edit-scheme-when-in-printers-or-done-stage": "No es pot editar l'esquema en les etapes de tipus 'Impressores' ni en les del grup 'Acabat'",
  "cannot-edit-printer-when-in-printers-or-done-stage": "No es pot editar la impressora en les etapes de tipus 'Impressores' ni en les del grup 'Acabat'",
  "Cannot save with a hidden printer": "No es pot guardar quan l'etapa és de tipus 'Impressores' i la impressora seleccionada no és visible",
  "column-order-not-configured-yet": "L'ordre de les columnes encara no s'ha configurat a \"Configuració\".",
  "Reset Order": "Restableix l'ordre",
  "Order Columns": "Ordre columnes",
  "Default column order and visibility": "Ordre i visibilitat de les columnes per defecte",
  "Configure Columns": "Configura les columnes",
  "Configure default column order": "Configura l'ordre predeterminat de les columnes",
  "Default Column Order": "Ordre de columnes per defecte",
  "Reorder Columns": "Reordena les columnes",
  "at-least-one-of-the-selected-items-is-currently-in-the-printers-stage-the-attached-print-job-will-be-cancelled-are-you-sure-you-want-to-move-it-out-of-that-stage": "L'element seleccionat es troba actualment a l'etapa d'impressores. El treball d'impressió adjunt es cancel·larà si encara no ha començat. Esteu segur que voleu treure'l de l'etapa?|Almenys un dels elements seleccionats es troba actualment a l'etapa d'impressores. Els treballs d'impressió adjunts es cancel·laran si encara no han començat. Esteu segur que voleu treure'ls de l'etapa?",
  "confirm-removing-from-printers-stage": "Confirmeu l'eliminació de l'etapa d'impressores",
  "at-least-one-of-the-selected-items-has-already-been-printed-are-you-sure-you-want-to-move-it-back-to-the-printers-stage": "L'element seleccionat ja s'ha imprès anteriorment. Esteu segur que voleu tornar-lo a moure a l'etapa d'impressores?|Almenys un dels elements seleccionats ja s'ha imprès anteriorment. Esteu segur que voleu tornar-los a moure a l'etapa d'impressores?",
  "confirm-moving-to-printers-stage": "Confirmeu el moviment a l'etapa d'impressores",
  "yes-move-it": "Sí, mou-ho",
  "no-keep-it": "No, guarda-ho",
  "the-selected-item-is-currently-in-the-printers-stage": "L'element seleccionat es troba actualment a l'etapa d'impressores.|Almenys un dels elements seleccionats es troba actualment a l'etapa d'impressores.",
  "Default printer": "Impressora per defecte",
  "Default scheme": "Esquema per defecte",
  "API Tokens & Devices": "Claus i dispositius API",
  "Starting batch number": "Número de lot inicial (el següent lot serà aquest número)",
  "Configure which columns are visible and their default order": "Configura quines columnes són visibles i el seu ordre predeterminat. \nAquests paràmetres s'utilitzaran com a valors de restabliment per a tots els usuaris.",
  "No tokens yet": "Encara no hi ha claus",
  "A token with this name already exists": "Ja existeix una clau amb aquest nom; Tria un altre nom",
  "Error generating token": "Error en generar la clau",
  "archive": "Arxivar",
  "cancel-jobs": "Cancel·lar treballs",
  "cancel-print-jobs": "Cancel·lar treball d'impressió|Cancel·lar treballs d'impressió",
  "cancel-print-job-disabled": "Només és possible cancel·lar treballs amb l'estat \"Pendent\" o \"Assignat\"",
  "reason-for-cancelling": "Motiu de la cancel·lació",
  "enter-reason-for-cancelling": "Introdueix un motiu per cancel·lar el treball d'impressió|Introdueix un motiu per cancel·lar els treballs d'impressió",
  "do-you-want-to-cancel-these-print-jobs": "Voleu cancel·lar aquest treball d'impressió?|Voleu cancel·lar aquests treballs d'impressió?",
  "cancel-print-job-printer-queue-warning": "Cancel·lar un treball d'impressió en aquest estat només canviarà el seu estat a CANCEL·LAT a Inèdit Connect. No el cancel·larà a la cua d'impressió. Si el treball continua a la impressora, l'haureu d'eliminar manualment des de la impressora.",
  "i-understand-cancel-print-job-printer-queue-warning": "Entenc que potser hauré d'eliminar aquest treball manualment de la cua de la impressora.",
  "print-jobs-cancelled-successfully": "Treball d'impressió cancel·lat correctament|Treballs d'impressió cancel·lats correctament",
  "failed-to-cancel-print-jobs": "S'ha produït un error en cancel·lar els treballs d'impressió",
  "unable-to-confirm-cancellation": "No s'ha pogut confirmar la cancel·lació",
  "cancel-print-job-timeout-warning": "No s'ha pogut confirmar la cancel·lació en el temps esperat. És possible que l'estat del treball no s'hagi actualitzat a la cua d'impressió.",
  "confirm-cancellation-anyway": "Confirmar cancel·lació de totes maneres",
  "print-job-in-printer-queue": "Treballs d'impressió a la cua de la impressora",
  "print-job-in-printer-queue-message": "Almenys un dels treballs d'impressió seleccionats està actualment a la cua de la impressora. La cancel·lació s'enviarà al Control Center per al seu processament.",
  "jobs-archived-successfully": "Treballs arxivats correctament",
  "error-while-archiving-jobs": "S'ha produït un error en arxivar els treballs",
  "Enter your token name": "Introdueix el teu nom de clau",
  "Generate a new token": "Genera una nova clau",
  "Drag to reorder and toggle visibility as your default": "Arrossega per reordenar i canviar la visibilitat. \nAquesta ordre s'utilitzarà com a ordre de columna predeterminat.",
  "Drag to reorder and toggle visibility as your company": "Arrossega per reordenar i canviar la visibilitat. \nAixò es convertirà en el valor predeterminat per a tots els usuaris quan restableixin les seves columnes.",
  "customers": "clients",
  "printer-queue": "Cua de la impressora",
  "unassigned-jobs": "Treballs no assignats",
  "Order Layout": "Plantilla",
  "printJobStatus": {
    "PENDING": "Pendent",
    "ASSIGNED": "Assignat",
    "PROCESSING": "Processant",
    "QUEUED": "En cua",
    "PRINTING": "Imprimint",
    "COMPLETED": "Completat",
    "ABORTED": "Interromput",
    "CANCELLED": "Cancel·lat"
  },
  "printJobType": {
    "PRINT": "Impressió",
    "REPRINT": "Reimpressió",
    "blankSpace": "Espai en blanc"
  },
  "Select Control Center": "Seleccionar Control Center",
  "save-and-create-job": "Desa i crea treball amb plantilla",
  "No items selected": "No s'ha seleccionat cap element",
  "are-you-sure-you-want-to-delete-this-comment": "Esteu segur que voleu suprimir aquest comentari?",
  "Choose a printer": "Tria una impressora",
  "Choose a scheme": "Tria un esquema",
  "Download PDF": "Descarregar PDF",
  "Error generating the job of the order": "Error en generar el treball de l'ordre",
  "Error generating the job of the order in the partner": "Error en generar el treball de l'ordre al soci",
  "Failed to load items for PDF": "No s'han pogut carregar els elements per a PDF",
  "Go Back": "Torna enrere",
  "Loading ink types data. Please wait": "Carregant dades de tipus de tinta. \nSi us plau, espereu",
  "Mail sent": "Correu enviat!",
  "Optimize outgoing jobs before sending them to your partner": "Optimitzar els treballs sortints abans d'enviar-los al teu soci",
  "Order Items": "Items d'ordre",
  "PDF Preview": "Vista prèvia del PDF",
  "reply-with-elipsis": "Respon...",
  "Version": "Versió",
  "Wrong URL": "URL incorrecte, torneu-ho a provar o poseu-vos en contacte amb l'administrador",
  "Exported": "Exportat",
  "item-moved-to-next-stage": "L'element s'ha mogut a l'etapa següent",
  "failed-to-move-item-to-next-stage": "No s'ha pogut moure l'element a l'etapa següent",
  "Select type": "Seleccionar el tipus",
  "export-csv": "Exportar CSV",
  "export-excel": "Exportar Excel",
  "group-by": "Agrupar per",
  "export-excel-selection-hint": "S'exportaran {n} element(s) seleccionat(s).",
  "export-excel-filters-hint": "Sense selecció: s'exportaran els elements que coincideixin amb els filtres actuals.",
  "export-excel-bucket-hint": "S'exportaran els elements d'aquesta agrupació.",
  "Excel exported successfully": "Excel exportat correctament",
  "There was an error exporting the Excel": "S'ha produït un error en exportar l'Excel",
  "Print job created successfully": "El treball d'impressió s'ha creat correctament",
  "Failed to create print job": "No s'ha pogut crear la tasca d'impressió",
  "Remove selected printer from jobs": "Elimina la impressora seleccionada dels treballs",
  "No printer": "Sense impressora",
  "Ink consumption": "Consum de tinta",
  "Percentage": "Percentatge",
  "Printed length": "Longitud impresa",
  "Print job updated successfully": "El treball d'impressió s'ha actualitzat correctament",
  "Failed to update print job": "No s'ha pogut actualitzar el treball d'impressió",
  "Edit print job": "Edita el treball d'impressió",
  "width-is-required-and-must-be-greater-than-0": "L'amplada és obligatòria i ha de ser superior a 0",
  "length-is-required-and-must-be-greater-than-0": "La longitud és obligatòria i ha de ser superior a 0",
  "Action": "Acció",
  "action": {
    "Nothing": "Cap",
    "Queue": "Posar a la cua",
    "Print": "Posar a la cua i imprimir"
  },
  "no-print-jobs": "No hi ha treballs d'impressió",
  "quantity-is-required-and-must-be-greater-than-0": "La quantitat és necessària i ha de ser superior a 0",
  "cannot-edit-print-job-in-status-status": "No es pot editar la tasca d'impressió en estat \"{estat}\"",
  "confirm-remove-from-queue": "Eliminar de la cua",
  "confirm-remove-from-queue-message": "Aquest treball d'impressió s'eliminarà de la cua. Vols continuar?",
  "action-is-required": "Selecciona una acció",
  "cant-print-automatically-without-a-printer-and-scheme": "No es pot imprimir automàticament sense una impressora i un esquema",
  "cant-print-automatically-with-a-printer-type-destination": "No es pot imprimir automàticament amb una impressora de tipus 'Destination'",
  "no-orders": "Sense ordres",
  "Print": "Imprimir...",
  "Print Jobs History": "Historial de treballs d'impressió",
  "New": "Nou",
  "no-users-found": "No s'han trobat usuaris",
  "this-stage-cannot-be-deleted-because-there-are-order-types-using-it": "Aquesta etapa no es pot eliminar perquè hi ha algún tipus de comanda que la utilitza",
  "this-stage-cannot-be-deleted-because-it-is-set-as-the-default-stage-of-the-workflow": "Aquesta etapa no es pot eliminar perquè està configurada com a etapa predeterminada del flux de treball",
  "this-stage-cannot-be-deleted-because-it-is-set-as-the-default-stage-in-some-of-your-partners-preferences": "Aquesta etapa no es pot eliminar perquè està configurada com a etapa predeterminada en les preferències d'alguns dels teus socis",
  "this-stage-cannot-be-deleted-because-it-has-order-items": "Aquesta etapa no es pot eliminar perquè té elements de comanda",
  "move-or-cancel-disabled": "Només és possible moure o cancel·lar treballs amb l'estat \"Pendent\" o \"Assignat\"",
  "the-item-does-not-exist-or-its-an-item-from-another-company": "L'item no existeix o és d'una altra empresa",
  "abort": "Interrompre",
  "reason-for-aborting": "Motiu de l'interrupció",
  "enter-reason-for-aborting": "Introdueix un motiu per interrompre el treball d'impressió",
  "field-is-required": "Aquest camp és obligatori",
  "field-must-have-at-least-n-characters": "Aquest camp ha de tenir almenys {n} caràcters",
  "print-job-aborted-successfully": "Treball d'impressió interromput correctament",
  "Custom field has values and cannot be deleted": "El camp personalitzat té valors i no es pot eliminar",
  "Go back": "Torna enrere",
  "some-image-files-formats-are-not-supported-in-layouts": "Alguns formats d'imatge dels fitxers no són compatibles amb les plantilles",
  "Download Log": "Descarrega els detalls del treball",
  "meters-selected": "metres seleccionats",
  "total-meters": "metres totals",
  "New print job": "Nou treball d'impressió",
  "Order Comments": "Comentaris de l'ordre",
  "Item Comments": "Comentaris de l'ítem",
  "layout-is-not-compatible-with-this-file-extension": "El disseny no és compatible amb aquesta extensió de fitxer",
  "Printers with print jobs cannot be deleted": "Les impressores amb treballs pendents no es poden eliminar",
  "you-dont-have-permission-to-edit-print-jobs": "No tens permís per editar treballs d'impressió",
  "move-to-stage": "Mou a l'etapa {stage}",
  "item-moved-to-stage": "Element mogut a l'etapa {stage}",
  "you-dont-have-permission-to-create-print-jobs": "No teniu permís per crear treballs d'impressió",
  "the-order-item-is-in-error-status": "L'ítem es troba en estat d'error",
  "no-printers-stage-configured": "Necessiteu tenir una etapa amb el Tipus \"Printers\" per crear treballs d'impressió",
  "Order comments": "Comentaris de l'ordre",
  "Item comments": "Comentaris de l'ítem",
  "Delivery date": "Data de lliurament",
  "Creator": "Creador",
  "deselect-all": "Desseleccionar tot",
  "ASSIGNED": "ASIGNAT",
  "QUEUED": "A LA CUA",
  "ABORTED": "FALLIT",
  "PENDING": "PENDENT",
  "PRINTING": "IMPRIMINT",
  "Abort date": "Data de fallida",
  "Abort Date": "Data de fallida",
  "COMPLETED": "COMPLETAT",
  "completed": "Completat",
  "pending": "Pendent",
  "assigned": "Assignat",
  "processing": "Processant",
  "queued": "En cua",
  "printing": "Imprimint",
  "aborted": "Fallit",
  "cancelled": "Cancel·lat",
  "Printed Length": "Longitud impresa",
  "Ink Consumption": "Consum de tinta",
  "End Date": "Data final",
  "Archive Date": "Data d'arxivament",
  "there-was-an-error-with-the-item-size-or-position-please-adjust-the-variables-and-try-again": "Hi ha hagut un error amb la mida o posició de l'element. Si us plau, ajusta les variables i torna-ho a provar.",
  "and-move-to": "i moure a",
  "CANCELLED": "CANCEL·LAT",
  "PROCESSING": "PROCESSANT",
  "Pause": "Pausar",
  "Resume": "Reprendre",
  "Unknown": "Desconegut",
  "Offline": "Desconectada",
  "Online": "Conectada",
  "Default measurement unit": "Unitat de mesura per defecte",
  "devices-and-apps": "Dispositius i aplicacions",
  "qr-reader": "Lector de QR",
  "API Tokens": "Claus API",
  "connect-with-neocatalog-to-acces-to-all-your-designs-you-will-be-able-to-create-new-orders-using-any-of-your-neocatalog-designs-and-colorways-with-just-a-click": "Connecta't amb neoCatalog per accedir a tots els teus dissenys. Podràs crear noves comandes usant qualsevol dels teus dissenys i colorits de neoCatalog amb un sol clic.",
  "connect-with-neocatalog": "Connecta't amb neoCatalog",
  "neoCatalog": "neoCatalog",
  "edit-neocatalog-connection": "Editar connexió amb neoCatalog",
  "neocatalog-connection-name": "Nom de la connexió",
  "neocatalog-api-token": "Token API de neoCatalog",
  "neocatalog-api-token-help": "Crea una clau API permanent a neoCatalog (Administració → Gestió → Usuaris → Tria un usuari → API Key) i enganxa-la aquí. ",
  "leave-blank-to-keep-current-token": "Deixa'l en blanc per mantenir el token actual",
  "neocatalog-connection-created": "neoCatalog connectat correctament",
  "neocatalog-connection-updated": "Connexió amb neoCatalog actualitzada",
  "neocatalog-disconnected": "neoCatalog desconnectat",
  "do-you-want-to-disconnect-neocatalog": "Vols desconnectar neoCatalog?",
  "Error connecting to neoCatalog": "Error en connectar amb neoCatalog",
  "Error disconnecting neoCatalog": "Error en desconnectar neoCatalog",
  "Connect": "Connectar",
  "Disconnect": "Desconnectar",
  "Token": "Token",
  "API Token": "Token API",
  "add-from-neocatalog": "Afegir des de neoCatalog",
  "replace-from-neocatalog": "Reemplaçar des de neoCatalog",
  "search-designs-by-name-or-code": "Cerca dissenys per nom o codi",
  "search-colorways-by-name-or-code": "Cerca colorits per nom o codi",
  "no-designs-found": "No s'han trobat dissenys",
  "no-colorways-found": "No s'han trobat colorits",
  "Error loading neoCatalog designs": "Error en carregar dissenys de neoCatalog",
  "Error loading neoCatalog colorways": "Error en carregar colorits de neoCatalog",
  "Error downloading neoCatalog file": "Error en descarregar l'arxiu de neoCatalog",
  "Next": "Següent",
  "Test": "Provar",
  "neocatalog-connection-test-ok": "La connexió amb neoCatalog és vàlida",
  "neocatalog-connection-test-failed": "La prova de connexió amb neoCatalog ha fallat",
  "enter-a-valid-url": "Introdueix una URL vàlida, incloent-hi http:// o https://. Es permeten adreces locals com https://hostname.local:2001.",
  "neocatalog-could-not-reach-server": "No s'ha pogut arribar a neoCatalog amb aquesta URL. Comprova que l'adreça sigui correcta i que el servidor sigui accessible.",
  "error-replacing-order-item-file-with-neocatalog-file": "Error en reemplaçar l'arxiu de l'ítem amb l'arxiu de neoCatalog",
  "error-adding-order-item-file-with-neocatalog-file": "Error en afegir l'arxiu de l'ítem amb l'arxiu de neoCatalog",
  "Hide Archived": "Amaga arxivats",
  "reset-sort": "Restableix ordenació",
  "Move to top": "Mou a dalt",
  "Move up": "Mou cap amunt",
  "Move down": "Mou cap avall",
  "Move to bottom": "Mou cap a baix",
  "reset-sort-to-reorder-manually": "Restableix ordenació per reordenar manualment",
  "only-possible-to-move-jobs-with-status": "Només és possible moure treballs amb l'estat \"Pendent\" o \"Assignat\"",
  "OrderItem": "Ítem d'ordre",
  "PrintJob": "Treball d'impressió",
  "Configure Order Items Columns": "Configurar columnes dels ítems",
  "Drag to reorder and toggle visibility for order item columns": "Arrossega per reordenar i triar quines columnes es mostren als ítems.",
  "order-items-dialog-created": "Diàleg d'ítems creat",
  "custom-field": "Personalitzat",
  "select-partner-stage-tooltip": "Selecciona un workflow stage del tipus Partners per habilitar aquesta opció",
  "no-partners-available": "No hi ha socis disponibles",
  "no-partners-available-tooltip": "No hi ha socis disponibles per a la teva empresa. Afegeix socis primer per utilitzar aquesta funció.",
  "no-accepted-partners": "No hi ha socis acceptats",
  "no-pending-invitations": "No hi ha invitacions pendents",
  "no-blocked-partners": "No hi ha socis bloquejats",
  "this-field-is-used-in-a-dialog-and-cannot-be-changed": "Aquest camp s'utilitza en un diàleg i no es pot canviar",
  "total": "total",
  "selected": "seleccionat",
  "History": "Historial",
  "material": "Material",
  "no-maximum": "Cap màxim",
  "choose-the-gap-size": "Tria la mida de l'espai en blanc",
  "print-blank-space-between-materials-in-batch": "Imprimir l'espai entre materials d'un lot",
  "print-blank-space-between-batches": "Imprimir l'espai entre lots",
  "force-sequential-jobs-description": "Envia els treballs en l'ordre de la cua. El treball següent espera fins que el treball anterior de la mateixa impressora hagi acabat de processar-se.",
  "Information": "Informació",
  "controlCenterErrors": {
    "printJobStuck": "Error: El treball d'impressió porta molt de temps en estat de processament",
    "fileUrlMissing": "Error: Falta la URL del fitxer.",
    "errorDownloadingFile": "Error en descarregar el fitxer:",
    "errorSendingOrder": "Error: Error en enviar la comanda al servidor d'impressió",
    "jobRemovedFromQueue": "Error: El treball ha estat eliminat de la cua."
  },
  "add-description": "Afegeix una descripció...",
  "No preview available": "No hi ha cap previsualització disponible",
  "Editing is disabled because item is already accepted": "L'edició està deshabilitada perquè l'element ja ha estat acceptat"
}
